const translations = {
    button: 'Add Controller'
};

export default translations;
